import * as React from 'react'
import { useReducer, useState } from 'react'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import CustomInput from '../input/CustomInput'
import Button from '../button/RegularButton'
import { timeout } from '../../App'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CustomDateInput from '../input/CustomDateInput'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { isBlank } from '../utils/StringUtils'
import { stringifyDates } from '../utils/DateUtils'
import { getApiUrl } from '../../api/api'

function subtenantReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'create':
      return {
        ...state,
      }

    case 'checkbox':
      return {
        ...state,
        universityConfirmation: !state.universityConfirmation,
      }

    case 'success':
      return {
        ...initialSubtenantState,
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialSubtenantState = {
  success: false,
  errorMessage: '',
  name: '',
  surname: '',
  email: '',
  room: '',
  movedIn: null,
  movedOut: null,
  universityConfirmation: false,
  id: '',
}

export default function CreateSubtenant() {
  const [state, dispatch] = useReducer(subtenantReducer, initialSubtenantState)
  const [notification, setNotification] = useState(initialNotificationState)

  const submitForm = (e) => {
    e.preventDefault()

    dispatch({ type: 'create' })

    if (isBlank(state.email)) {
      setNotification({
        open: true,
        message: 'Bitte Email eintragen.',
        color: 'danger',
      })
      return
    }

    getApiUrl()
      .post(`/admin/subtenants`, stringifyDates(state))
      .then(function() {
        dispatch({ type: 'success' })
        setNotification({
          open: true,
          message: 'Untermieter hinzugefügt',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Untermieter Vorname"
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.name,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'name',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Untermieter Nachname"
              id="surname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.surname,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'surname',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Untermieter Email"
              id="email"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.email,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'email',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <CustomInput
              labelText="Zimmer"
              id="room"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.room,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'room',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomDateInput
              labelText="Einzug"
              id="movedIn"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.movedIn,
                onChange: (date) =>
                  dispatch({
                    type: 'field',
                    field: 'movedIn',
                    value: date,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomDateInput
              labelText="Auszug"
              id="movedOut"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.movedOut,
                onChange: (date) =>
                  dispatch({
                    type: 'field',
                    field: 'movedOut',
                    value: date,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={2}>
            <FormControlLabel
              value="universityConfirmation"
              control={
                <Checkbox
                  checked={state.universityConfirmation}
                  onChange={() =>
                    dispatch({
                      type: 'checkbox',
                    })
                  }
                />
              }
              style={{ marginTop: '43px' }}
              label="Bestätigung Partneruniversität"
              labelPlacement="end"
            />
          </GridItem>
        </GridContainer>
        <br/>
        <Button
          color="primary"
          onClick={(e) => {
            submitForm(e)
          }}>
          Untermieter hinzufügen
        </Button>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridItem>
    </GridContainer>
  )
}
